import './index.less';

import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
// import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import { HashRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import router from './router';

import AuthProvider from 'admin/Auth';
// import OmegaTracker from '@didi/omega-tracker-lite';

// const config = { appKey: 'omega742c278ca8' };
// window.Omega = OmegaTracker.getTracker(config);


class App extends Component {
  render() {
    return (
      <AuthProvider needLogin={false}>
        <ConfigProvider locale={zhCN}>
          <Router>
            <Switch>
              <Route
                exact
                path="/"
              >
                <Redirect to={router[0].path} />
              </Route>
              {
                router.map(item => (
                  <Route
                    exact={item.exact}
                    key={item.path}
                    path={item.path}
                    component={item.component}
                  />
                ))
              }
            </Switch>
          </Router>
        </ConfigProvider >
      </AuthProvider>
    );
  }
}

ReactDOM.render(<App />, document.getElementById('app'));
